import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularSvgIconModule } from "angular-svg-icon";
import Components, { UiSvgComponent } from "./components";

@NgModule({
  imports: [CommonModule, AngularSvgIconModule.forRoot()],
  declarations: [Components],
  exports: [AngularSvgIconModule, UiSvgComponent]
})
export class UiSvgModule {}
